import React, { Component } from "react";
import ReactDOM from "react-dom";

import { animateScroll as scroll } from "react-scroll";

import ReactGA from "react-ga";
import { Row, Col } from "react-bootstrap";
import { Button, Icon } from "semantic-ui-react";

import moment from "moment";
import { Helmet } from "react-helmet";

import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Sidebar from "../../Sidebar/Sidebar";

import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";

import ItinerariesSidebar from "../Itineraries/ItinerariesSidebar";

import { translate, getLanguage } from "../../Translation/Translation";
import { FETCH_URL } from "../../../utilities";

import "./SingleItinerary.css";

const Arrow = () => (
  <div className="timeArrow">
    <svg
      viewBox="0 0 1000 1000"
      className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
    >
      <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
    </svg>
  </div>
);

class SingleItinerary extends Component {
  state = { preselectedTrip: null };

  componentWillUpdate(nextProps) {
    const { itineraries, selectOutgoing, selectIncoming } = this.props;

    if (itineraries !== nextProps.itineraries) {
      selectIncoming(null);
      selectOutgoing(null);
    }
  }

  handleSelectTrip(event, trip) {
    event.preventDefault();
    const { outgoing, incoming, selectOutgoing, selectIncoming } = this.props;

    if (outgoing) {
      localStorage.setItem("outgoingTrip", JSON.stringify(trip));
      localStorage.setItem(
        "departureLocation",
        JSON.stringify(trip.departureLocation)
      );
      localStorage.setItem(
        "arrivalLocation",
        JSON.stringify(trip.arrivalLocation)
      );
      selectOutgoing(trip);
    } else if (incoming) {
      localStorage.setItem("incomingTrip", JSON.stringify(trip));
      localStorage.setItem(
        "departureLocation",
        JSON.stringify(trip.departureLocation)
      );
      localStorage.setItem(
        "arrivalLocation",
        JSON.stringify(trip.arrivalLocation)
      );
      selectIncoming(trip);
    }
  }

  renderInfo() {
    const { outgoing, incoming, itineraries } = this.props;
    const firstTripWithTrips = itineraries.find((trip) => trip.trips.length);
    return (
      <div>
        <div className="stepLabel" style={{ margin: "0px" }}>
          {translate(
            getLanguage(),
            outgoing ? "Departure" : incoming && "Return"
          )}
        </div>
        <div>
          <div className="portName">
            {firstTripWithTrips &&
              firstTripWithTrips.trips[0].departureLocation.name}
          </div>
          <div className="portArrow">
            <svg
              viewBox="0 0 1000 1000"
              className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
            >
              <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
            </svg>
          </div>
          <div className="portName">
            {firstTripWithTrips &&
              firstTripWithTrips.trips[0].arrivalLocation.name}
          </div>
        </div>
        <div>
          <div className="departureDayLabel">
            {translate(
              getLanguage(),
              outgoing ? "Departure Date" : incoming ? "Arrival Date" : null
            )}
          </div>
          <div className="departureDayText">
            {outgoing
              ? itineraries.selectedOutgoingTrip ||
                JSON.parse(localStorage.getItem("outgoingTrip"))
                ? moment(
                    (itineraries.selectedOutgoingTrip &&
                      itineraries.selectedOutgoingTrip.departureDateTime) ||
                      JSON.parse(localStorage.getItem("outgoingTrip"))
                        .departureDateTime
                  ).format("dddd DD MMMM YYYY")
                : "Not selected"
              : (incoming && itineraries.selectedIncomingTrip) ||
                JSON.parse(localStorage.getItem("incomingTrip"))
              ? moment(
                  (itineraries.selectedIncomingTrip &&
                    itineraries.selectedIncomingTrip.departureDateTime) ||
                    JSON.parse(localStorage.getItem("incomingTrip"))
                      .departureDateTime
                ).format("dddd DD MMMM YYYY")
              : "Not selected"}
          </div>
        </div>
      </div>
    );
  }

  renderTrips(trips) {
    const { itineraries, incoming, outgoing } = this.props;
    const selectedTrip = outgoing
      ? itineraries.selectedOutgoingTrip ||
        JSON.parse(localStorage.getItem("outgoingTrip"))
      : (incoming && itineraries.selectedIncomingTrip) ||
        JSON.parse(localStorage.getItem("incomingTrip"));
    return (
      <div className="single-itinerary-trip-trips">
        {trips.map((trip, index) => {
          const dTime = moment(trip.departureDateTime);
          const aTime = moment(trip.arrivalDateTime);
          return (
            <div
              key={index}
              className={
                selectedTrip
                  ? trip.vessel.id === selectedTrip.vessel.id &&
                    trip.departureDateTime === selectedTrip.departureDateTime &&
                    trip.arrivalDateTime === selectedTrip.arrivalDateTime
                    ? "single-itinerary-trip selected"
                    : "single-itinerary-trip"
                  : "single-itinerary-trip"
              }
            >
              <div className="company-logo">
                <img src={trip.company.imageUrl} alt="company-logo" />
              </div>
              <span className="vessel-info">{trip.vessel.name}</span>
              <div className="trip-times">
                <span>{dTime.format("HH:mm")}</span>
                <Arrow />
                <span>{aTime.format("HH:mm")}</span>
              </div>
              <div className="trip-button-container">
                <button
                  className={
                    selectedTrip
                      ? trip.vessel.id === selectedTrip.vessel.id &&
                        trip.departureDateTime ===
                          selectedTrip.departureDateTime &&
                        trip.arrivalDateTime === selectedTrip.arrivalDateTime
                        ? "trip-button selected"
                        : "trip-button"
                      : "trip-button"
                  }
                  onClick={(event) => this.handleSelectTrip(event, trip)}
                >
                  {selectedTrip
                    ? trip.vessel.id === selectedTrip.vessel.id &&
                      trip.departureDateTime ===
                        selectedTrip.departureDateTime &&
                      trip.arrivalDateTime === selectedTrip.arrivalDateTime
                      ? translate(getLanguage(), "Selected")
                      : translate(getLanguage(), "Select")
                    : translate(getLanguage(), "Select")}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderItineraries() {
    const { itineraries } = this.props;
    const tripList = itineraries;

    return (
      <div className="single-itinerary-trips-container">
        {tripList.map((day) => {
          const date = moment(day.tripDate);
          return (
            <div key={date} className="single-itinerary-trip-container">
              <div className="single-itinerary-trip-date">
                <span>{date.format("dddd")}</span>
                <span>{date.format("D MMM")}</span>
              </div>
              {this.renderTrips(day.trips)}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <Row>
        {this.renderInfo()}
        {this.renderItineraries()}
      </Row>
    );
  }
}

class Itineraries extends Component {
  state = { prevWidth: window.innerWidth, loading: true, yPos: 0 };

  updateDimensions = () => {
    const newWidth = window.innerWidth;
    const { prevWidth } = this.state;

    if (newWidth < 410 && prevWidth >= 410) {
      this.setState({ prevWidth: newWidth });
      this.searchItineraries(this.props);
    } else if (
      newWidth > 410 &&
      newWidth <= 1060 &&
      (prevWidth <= 410 || prevWidth > 1060)
    ) {
      this.setState({ prevWidth: newWidth });
      this.searchItineraries(this.props);
    } else if (
      newWidth > 1060 &&
      newWidth <= 1230 &&
      (prevWidth <= 1060 || prevWidth > 1230)
    ) {
      this.setState({ prevWidth: newWidth });
      this.searchItineraries(this.props);
    } else if (newWidth > 1230 && prevWidth <= 1230) {
      this.setState({ prevWidth: newWidth });
      this.searchItineraries(this.props);
    }
  };

  getRange = () => {
    const { prevWidth } = this.state;
    if (prevWidth < 410) {
      return 0;
    } else if (prevWidth < 1060) {
      return 1;
    } else if (prevWidth < 1230) {
      return 2;
    } else {
      return 3;
    }
  };

  goToPrint = (event) => {
    const {
      history,
      match: {
        params: { from, to, sdate, edate },
      },
    } = this.props;
    event.preventDefault();
    history.push(
      `/mg/${getLanguage()}/ferries-schedules/${from}/${to}/${sdate}/${edate}`
    );
  };

  goToBooking = (event) => {
    const {
      history,
      match: {
        params: { from, to, sdate, edate },
      },
    } = this.props;
    const {
      data: {
        settings: { isRoundTrip },
      },
    } = this.props;

    const outgoingTrip = JSON.parse(localStorage.getItem("outgoingTrip"));

    if (isRoundTrip) {
      ReactGA.event({
        category: "Routes",
        action: "SearchRoutes",
        label: `RoundTrip#${moment(sdate).format("YYYYMMDD")}#${moment(
          outgoingTrip.departureDateTime
        ).format("hhmm")}#${outgoingTrip.departureLocation.id}#${
          outgoingTrip.arrivalLocation.id
        }#2#${moment(sdate).format("YYYYMMDD")}#${moment(edate).format(
          "YYYYMMDD"
        )}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`,
      });
    } else {
      ReactGA.event({
        category: "Routes",
        action: "SearchRoutes",
        label: `OneWayTrip#${moment(sdate).format("YYYYMMDD")}#${moment(
          outgoingTrip.departureDateTime
        ).format("hhmm")}#${outgoingTrip.departureLocation.id}#${
          outgoingTrip.arrivalLocation.id
        }#1#${moment(sdate).format(
          "YYYYMMDD"
        )}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`,
      });
    }
    if (isRoundTrip) {
      ReactGA.event({
        category: "Destination",
        action: "SearchDestination",
        label: `SearchDestination#${moment(sdate).format("YYYYMMDD")}#${moment(
          outgoingTrip.departureDateTime
        ).format("hhmm")}#${outgoingTrip.arrivalLocation.id}#2#${moment(
          sdate
        ).format("YYYYMMDD")}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`,
      });
    } else {
      ReactGA.event({
        category: "Destination",
        action: "SearchDestination",
        label: `SearchDestination#${moment(sdate).format("YYYYMMDD")}#${moment(
          outgoingTrip.departureDateTime
        ).format("hhmm")}#${outgoingTrip.arrivalLocation.id}#1#${moment(
          sdate
        ).format("YYYYMMDD")}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`,
      });
    }
    ReactGA.event({
      category: "Destination",
      action: "SearchDestination",
      label: `SearchDestination#${moment(sdate).format("YYYYMMDD")}#${moment(
        outgoingTrip.departureDateTime
      ).format("hhmm")}#${outgoingTrip.arrivalLocation.id}#1#${moment(
        sdate
      ).format("YYYYMMDD")}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`,
    });

    event.preventDefault();
    history.push(`/${from}/${to}/${sdate}/${edate}/ships`);
  };

  searchItineraries = ({
    match: {
      params: { from, to, sdate, edate },
    },
    data: {
      setOutgoingTrips,
      setIncomingTrips,
      setOutgoingDestinationTrips,
      setIncomingDestinationTrips,
    },
  }) => {
    this.setState({ loading: true });
    return fetch(`${FETCH_URL}/proxy.php?ws=5a84eaef340463398015c41e8361c199`, {
      method: "POST",
      body: JSON.stringify({
        outgoingLocationCode: `${from === "ALL" ? "" : from}`,
        incomingLocationCode: `${to === "ALL" ? "" : to}`,
        outgoingDate: `${sdate}`,
        incomingDate: `${edate}`,
        languageCode: `${getLanguage()}`,
        includeEvents: true,
        dayRange: this.getRange(),
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        this.setState({ loading: false });
        setOutgoingTrips(json.outgoingTrips);
        setIncomingTrips(json.incomingTrips);
        setOutgoingDestinationTrips(json.outgoingDestinationTrips);
        setIncomingDestinationTrips(json.incomingDestinationTrips);
        return json;
      })
      .then(() => this._scrollTo());
  };

  _scrollTo = () => {
    this.setTimeOut = setTimeout(() => scroll.scrollTo(500), 250);
  };

  componentWillReceiveProps(nextProps) {
    const { from, to, sdate, edate } = nextProps.match.params;
    const {
      searchDeparturePortCode,
      searchArrivalPortCode,
      searchStartDay,
      searchEndDay,
    } = nextProps.data.itineraries;

    if (
      from !== searchDeparturePortCode ||
      to !== searchArrivalPortCode ||
      sdate !== searchStartDay ||
      edate !== searchEndDay
    ) {
      this.searchItineraries(nextProps);
    }
  }

  componentWillUpdate(nextProps) {
    const outgoingTrip = JSON.parse(localStorage.getItem("outgoingTrip"));
    if (outgoingTrip) {
      if (
        nextProps.match.params.from !== outgoingTrip.departureLocation.code ||
        nextProps.match.params.to !== outgoingTrip.arrivalLocation.code ||
        nextProps.match.params.sdate !== this.props.match.params.sdate
      ) {
        localStorage.removeItem("incomingTrip");
        localStorage.removeItem("arrivalLocation");
        localStorage.removeItem("outgoingTrip");
        localStorage.removeItem("departureLocation");
      }
    }
  }

  componentDidMount() {
    this.setState({
      yPos: ReactDOM.findDOMNode(this.contentRef).getBoundingClientRect().y,
    });
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
    this.searchItineraries(this.props);

    const outgoingTrip = JSON.parse(localStorage.getItem("outgoingTrip"));
    if (outgoingTrip) {
      if (
        this.props.match.params.from !== outgoingTrip.departureLocation.code ||
        this.props.match.params.to !== outgoingTrip.arrivalLocation.code
      ) {
        localStorage.removeItem("incomingTrip");
        localStorage.removeItem("arrivalLocation");
        localStorage.removeItem("outgoingTrip");
        localStorage.removeItem("departureLocation");
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    clearTimeout(this.setTimeOut);
  }

  render() {
    const { loading } = this.state;
    const {
      data: {
        itineraries,
        settings: { isRoundTrip },
        setSelectedOutgoingTrip,
        setSelectedIncomingTrip,
      },
    } = this.props;
    return (
      <div className="no-padding">
        <Helmet>
          <title>Book your Itinerary | Openseas</title>
        </Helmet>
        <Row>
          <Col xs={12}>
            <Header data={this.props} />
          </Col>
        </Row>
        <Row
          className="BannerRectangleLarge"
          style={{ margin: "8px 0 8px 0", textAlign: "center" }}
        >
          <BannerRectangleLarge osCode={this.props.match.params.to} />
        </Row>
        <Row
          style={{ margin: "0px" }}
          className="no-padding"
          ref={(node) => {
            this.contentRef = node;
          }}
        >
          <div className="OSPageContainer">
            <div className="OSPageContent contentOnMDandBelow ItinerariesPageContent">
              <Row style={{ margin: "0px", marginTop: "20px" }}>
                <div className="stepCounter">1</div>
                <div className="stepLabel">
                  {translate(getLanguage(), "Select Travel Dates")}
                </div>
              </Row>
              <Row style={{ marginTop: "24px" }}>
                {!loading && (
                  <div style={{ float: "right", display: "inline-block" }}>
                    <Button
                      icon
                      labelPosition="left"
                      style={{ borderRadius: 20, marginRight: 8 }}
                      onClick={this.goToPrint}
                    >
                      <Icon name="print" style={{ padding: 0 }} />
                      {translate(getLanguage(), "Print")}
                    </Button>
                    <Button
                      className="searchButton"
                      primary
                      loading={this.props.isloading}
                      onClick={this.goToBooking}
                      disabled={
                        isRoundTrip
                          ? !(
                              (itineraries.selectedIncomingTrip ||
                                JSON.parse(
                                  localStorage.getItem("incomingTrip")
                                )) &&
                              (itineraries.selectedOutgoingTrip ||
                                JSON.parse(
                                  localStorage.getItem("outgoingTrip")
                                ))
                            )
                          : !(
                              itineraries.selectedOutgoingTrip ||
                              JSON.parse(localStorage.getItem("outgoingTrip"))
                            )
                      }
                    >
                      {translate(getLanguage(), "Continue to booking")}
                    </Button>
                  </div>
                )}
                {loading ? (
                  <div>...loading</div>
                ) : isRoundTrip ? (
                  <div>
                    {itineraries.OutgoingTripList.length > 0 && (
                      <SingleItinerary
                        itineraries={itineraries.OutgoingTripList}
                        outgoing
                        selectOutgoing={setSelectedOutgoingTrip}
                        selectIncoming={setSelectedIncomingTrip}
                      />
                    )}
                    {itineraries.IncomingTripList.length > 0 && (
                      <SingleItinerary
                        itineraries={itineraries.IncomingTripList}
                        incoming
                        selectOutgoing={setSelectedOutgoingTrip}
                        selectIncoming={setSelectedIncomingTrip}
                      />
                    )}
                  </div>
                ) : (
                  itineraries.OutgoingTripList.length > 0 && (
                    <div>
                      <SingleItinerary
                        itineraries={itineraries.OutgoingTripList}
                        outgoing
                        selectOutgoing={setSelectedOutgoingTrip}
                        selectIncoming={setSelectedIncomingTrip}
                      />
                    </div>
                  )
                )}
              </Row>
              {itineraries.outgoingDestinationTrips.length > 0 &&
                itineraries.outgoingDestinationTrips.map((itinerary, index) => {
                  return (
                    <SingleItinerary
                      key={index}
                      itineraries={itinerary.trips}
                      outgoing
                      selectOutgoing={setSelectedOutgoingTrip}
                      selectIncoming={setSelectedIncomingTrip}
                    />
                  );
                })}
              {itineraries.incomingDestinationTrips.length > 0 &&
                isRoundTrip &&
                itineraries.incomingDestinationTrips.map((itinerary, index) => {
                  return (
                    <SingleItinerary
                      key={index}
                      itineraries={itinerary.trips}
                      incoming
                      selectOutgoing={setSelectedOutgoingTrip}
                      selectIncoming={setSelectedIncomingTrip}
                    />
                  );
                })}

              {!loading && (
                <Button
                  style={{ float: "right", position: "relative" }}
                  className="searchButton"
                  primary
                  loading={this.props.isloading}
                  onClick={this.goToBooking}
                  disabled={
                    isRoundTrip
                      ? !(
                          (itineraries.selectedIncomingTrip ||
                            JSON.parse(localStorage.getItem("incomingTrip"))) &&
                          (itineraries.selectedOutgoingTrip ||
                            JSON.parse(localStorage.getItem("outgoingTrip")))
                        )
                      : !(
                          itineraries.selectedOutgoingTrip ||
                          JSON.parse(localStorage.getItem("outgoingTrip"))
                        )
                  }
                >
                  {translate(getLanguage(), "Continue to booking")}
                </Button>
              )}
            </div>
            <div className="OSPageSidebar showOnMDandBelow">
              <ItinerariesSidebar
                incomingTrip={
                  itineraries.selectedIncomingTrip ||
                  JSON.parse(localStorage.getItem("incomingTrip"))
                }
                outgoingTrip={
                  itineraries.selectedOutgoingTrip ||
                  JSON.parse(localStorage.getItem("outgoingTrip"))
                }
                shouldDisplayReturn={isRoundTrip}
                language={getLanguage()}
              />
            </div>
            <div className="OSPageSidebar">
              <ItinerariesSidebar
                incomingTrip={
                  itineraries.selectedIncomingTrip ||
                  JSON.parse(localStorage.getItem("incomingTrip"))
                }
                outgoingTrip={
                  itineraries.selectedOutgoingTrip ||
                  JSON.parse(localStorage.getItem("outgoingTrip"))
                }
                shouldDisplayReturn={isRoundTrip}
                language={getLanguage()}
              />
              <Sidebar osCode={this.props.match.params.to} />
            </div>
          </div>
        </Row>
        <Row style={{ margin: "0px" }}>
          <Footer />
        </Row>
      </div>
    );
  }
}

export default Itineraries;



// WEBPACK FOOTER //
// ./src/components/Pages/Itineraries2/Itineraries2.js